module.exports = __webpack_public_path__ + "assets/img/login-bg@2x.abaaef0a.png";